module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap myoreders-wrap personal-wrap"
  }, [(_vm.loadShow) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.loadShow,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getGoodsCommentList.length == 0 && !_vm.loadShow) ? _c('empty', {
    attrs: {
      "imgpath": "/static/images/empty_evaluation_3x.png",
      "emptytext": "您还没有商品评价",
      "btnurl": "/main/home",
      "btntext": "去逛一逛"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "flex-column flex-item orders-list"
  }, [_vm._l((_vm.getGoodsCommentList), function(getGoodsMsg) {
    return (_vm.getGoodsCommentList.length != 0) ? _c('div', {
      staticClass: "orders-list-item"
    }, [_c('mu-list', {
      staticStyle: {
        "border-bottom": "1px solid #f5f7f9"
      }
    }, _vm._l((_vm.getGoodsCommentList), function(goodsShow, goodsIndex) {
      return _c('myOrdersItem', {
        key: goodsIndex,
        attrs: {
          "width": 150,
          "height": 150,
          "cartitem": goodsShow,
          "isRightTriggle": 'true'
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "comment-box"
    }, [_c('p', {
      staticClass: "comment"
    }, [_vm._v(_vm._s(getGoodsMsg.commDesc))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(getGoodsMsg.commTime))]), _vm._v(" "), (0) ? _c('div', {
      staticClass: "reply"
    }, [_c('p', {
      staticClass: "triangle"
    }), _vm._v(" "), _c('p', [(getGoodsMsg.commentReplys.length == 0) ? _c('label', {
      staticClass: "orange"
    }, [_vm._v("商家回复：")]) : _vm._e(), _vm._v("\n            " + _vm._s(getGoodsMsg.commentReplys && getGoodsMsg.commentReplys.replyDesc) + "\n            ")]), (getGoodsMsg.commentReplys.length != 0) ? _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(getGoodsMsg.commentReplys && getGoodsMsg.commentReplys.replyTime))]) : _vm._e(), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "operate"
    }, [_c('p', {
      staticClass: "edit-address fr",
      on: {
        "click": function($event) {
          return _vm.editAddress(getGoodsMsg.commId)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('p', {
      staticClass: "delete-address fr",
      on: {
        "click": function($event) {
          return _vm.deleteAddress(getGoodsMsg.commId)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])])], 1) : _vm._e()
  }), _vm._v(" "), _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading,
      "loadingText": ""
    },
    on: {
      "load": _vm.loadMore
    }
  }), _vm._v(" "), ((_vm.lastPageNo == _vm.currentPage && !_vm.loadShow) || (_vm.total == 0 && !_vm.loadShow)) ? _c('p', {
    staticClass: "none-goods"
  }, [_vm._v("没有更多评价啦~")]) : _vm._e()], 2), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.isDelete,
      "title": "删除评论",
      "titleClass": "dialogTitle",
      "bodyClass": "dialogBody",
      "actionsContainerClass": "dialogActionsContainer"
    },
    on: {
      "close": function($event) {
        _vm.isDelete = false
      }
    }
  }, [_vm._v("\n    确定删除这个评论？\n    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "否"
    },
    on: {
      "click": function($event) {
        _vm.isDelete = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.closedeleteAddress
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ef0e306","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/mycomments.vue
// module id = 382
// module chunks = 68